import { render, staticRenderFns } from "./xtpage.vue?vue&type=template&id=713f1d0e&scoped=true&"
import script from "./xtpage.vue?vue&type=script&lang=js&"
export * from "./xtpage.vue?vue&type=script&lang=js&"
import style0 from "./xtpage.vue?vue&type=style&index=0&id=713f1d0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713f1d0e",
  null
  
)

export default component.exports